import { KeyboardEvent, useEffect, useRef, useState } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { useMouseContent } from "src/utils/mouse/mouseContent";

import { useMST3010_R01Store } from "./Store_MST3010_R01";
import { SearchSection_MST3010_R01 } from "./SearchSection_MST3010_R01";
import { Info_MST3010_R01 } from "./Info_MST3010_R01";
import { Table_MST3010_R01 } from "./Table_MST3010_R01";
import { Content_MST3010_R01 } from "./Content_MST3010_R01";
import { MST3010_R01Dto } from "./Dto_MST3010_R01";
import { AgGridReact } from "ag-grid-react";

export const Container_MST3010_R01 = () => {

	const {
		setMST3010_R01List, removeMST3010_R01,
		selectedMST3010_R01, setSelectedMST3010_R01,
		editMST3010_R01, setEditMST3010_R01,
		initData,
	} = useMST3010_R01Store();
	
	const { yesNoList,} = useCommonCodeStore();
	const { setMessage } = useUiuxStore();


	// 버튼 비활성화 상태 관리
	const [buttonDisabled, setButtonDisabled] = useState({
		fetch: false,
		create: false,
		delete: true,
		save: true,
		print: true,
		excel: true,
		init: false
	});

	// 선택된 공정이 변경될 때 버튼 상태 업데이트
	useEffect(() => {
		setButtonDisabled(prev => ({
			...prev,
			delete: !selectedMST3010_R01,
			save: !selectedMST3010_R01 && !editMST3010_R01.workplaceCd,
			print: !selectedMST3010_R01,
			excel: !selectedMST3010_R01
		}));
	}, [selectedMST3010_R01, editMST3010_R01]);

	const RESIZER = {
		code: 'MST3010_R01',
		type: 'height',
		storageKey: 'workplace-split-height',
		min: 5,
		max: 80,
		default: 27
	} as const;
	const gridRef = useRef<AgGridReact<MST3010_R01Dto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef,
	});

	const {
		handleExcelClick,
		fetchData,
		initContainerData,
		outWarehouseCdListToUse,
		inWarehouseCdListToUse,
		badWarehouseCdListToUse,
		plcListToUse,
		defaultMST3010_R01Row,
		handleCreateClick,
		handleSaveClick,
		handleDeleteClick,
	} = Content_MST3010_R01({
		gridRef,
		setMessage,
		
	});

	return <div className="content-container">
    <Actionbar
		onFetchClick={fetchData}
		onCreateClick={handleCreateClick}
		onDeleteClick={handleDeleteClick}
		onSaveClick={handleSaveClick}
		onExcelClick={handleExcelClick}
		onInitClick={initContainerData}
    />
    <SearchSection_MST3010_R01
		onEnterKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
			if (e.key === 'Enter') {
				fetchData()
			}
		}}
		yesnoOptions={yesNoList}
	/>
    <div className="flex flex-1 flex-col px-[12px] gap-[4px] overflow-x-auto p-[10px]" ref={containerRef}>
		<div className="w-full" style={{ height: `${splitValue}%` }}>
        	<Info_MST3010_R01 
				data={selectedMST3010_R01}
				outWarehouseCdListToUse={outWarehouseCdListToUse}
				inWarehouseCdListToUse={inWarehouseCdListToUse}
				badWarehouseCdListToUse={badWarehouseCdListToUse}
				plcListToUse={plcListToUse} // "연동 PLC ID" 드롭다운 옵션(선택 사업장 PLC)
				defaultMST3010_R01Row={defaultMST3010_R01Row()}
			/>
		</div>
      	{/* 리사이저 */}
		<div
        	className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
        	onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown("UD", e.nativeEvent) }
			// 드래그 시작 방지
			onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
		/>
		<div className="w-full " style={{ height: `${100 - splitValue}%` }}>
        	<Table_MST3010_R01 gridRef={gridRef} defaultMST3010_R01Row={defaultMST3010_R01Row()} />
		</div>
    </div>
    <Message />
	</div>
} 